import { PortalNewsPostObjClass } from "scrivito/Objs/PortalNewsPost/PortalNewsPostObjClass"
import { getCurrentSiteID } from "shared/lib/getCurrentSiteID"

export function getPortalNewsInRange(
  from: Date | null | undefined,
  to: Date | null | undefined,
  parentPath?: string | null | undefined
) {
  const siteContext = PortalNewsPostObjClass.onSite(getCurrentSiteID()).where(
    "_path",
    "contains",
    parentPath ?? "/"
  )
  if (from && to) {
    return siteContext
      .and("date", "isLessThan", to)
      .and("date", "isGreaterThan", from)
  }
  if (from) {
    return siteContext.and("date", "isGreaterThan", from)
  }
  if (to) {
    return siteContext.and("date", "isLessThan", to)
  }
  return siteContext
}
